module.exports = __webpack_public_path__ + "img/logoAmazon.831bd59c.png";